var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSaveFamilyMemsCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 162,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M0 0h308.053v162.178H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.311 21.896H80.859a6.177 6.177 0 00-6.203 6.203v105.79a6.177 6.177 0 006.203 6.203h66.449a7.24 7.24 0 006.72 4.48 7.238 7.238 0 006.719-4.48h66.449a6.177 6.177 0 006.203-6.203V28.099c.115-3.388-2.699-6.203-6.088-6.203z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.742 31.258v99.472h68.345V42.227c0-6.03-4.882-10.97-10.97-10.97H85.742z",
    fill: "#B4E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.43 31.258h-57.375c-6.03 0-10.969 4.882-10.969 10.97v88.56h68.344v-99.53z",
    fill: "#B4E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.742 120.163v10.568h68.345a10.54 10.54 0 00-10.568-10.568H85.742z",
    fill: "#4198BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.43 120.163h-57.777a10.54 10.54 0 00-10.567 10.568h68.344v-10.568z",
    fill: "#4198BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.368 41.366h-19.661v1.895h19.661v-1.895zM142.368 45.387h-19.661v1.895h19.661v-1.895zM142.368 49.406h-19.661v1.895h19.661v-1.895zM142.368 53.427h-19.661v1.895h19.661v-1.895zM142.368 57.447h-19.661v1.895h19.661v-1.895zM142.368 101.67h-19.661v1.895h19.661v-1.895zM142.368 105.69h-19.661v1.896h19.661v-1.896zM138.641 109.711h-15.934v1.895h15.934v-1.895zM213.411 41.366h-47.266v1.895h47.266v-1.895zM213.411 45.387h-47.266v1.895h47.266v-1.895zM213.411 49.406h-47.266v1.895h47.266v-1.895zM213.411 53.427h-47.266v1.895h47.266v-1.895zM213.411 57.447h-47.266v1.895h47.266v-1.895z",
    fill: "#3D7E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.164 77.672l-3.861-5.15-3.862 5.15V30.478h7.723v47.194z",
    fill: "#73768C"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M184.051 64.801l40.746 5.57-5.57 40.747-40.747-5.571z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1C1C1",
    d: "M186.52 68.051l35.027 4.789-3.323 24.304-35.027-4.79z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 68,
    width: 39,
    height: 30
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(7.785 186.52 68.05)",
    fill: "#C1C1C1",
    d: "M186.52 68.051h35.353v24.53H186.52z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.244 92.78l.382 3.425-11.31 1.264-.383-3.425a5.697 5.697 0 01.936-3.817 5.675 5.675 0 014.081-2.473 5.645 5.645 0 014.184 1.215 5.617 5.617 0 012.11 3.81z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.375 91.916c-.603 1.968-1.076 3.716-1.394 5.242l-4.874.545c.204-1.847.739-3.847 1.689-5.93.339-.758.71-1.236 1.072-1.56.422-.367.842-.517 1.278-.643.637-.161 2.882.256 2.229 2.346z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.618 81.895l4.001.357c-.052.55-.611 5.745-1.179 7.638-.25.563-1.293.65-2.3.2-.911-.408-1.489-1.128-1.424-1.675.335-1.145.72-4.606.902-6.52z",
    fill: "#7FA7B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.883 71.999l-10.604 9.79 24.32-1.303-11.591-8.611a1.665 1.665 0 00-2.125.124z",
    fill: "#35395E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.523 82.65c6.713-.357 12.123-1.252 12.083-1.998-.04-.747-5.515-1.062-12.228-.704-6.713.358-12.123 1.253-12.083 1.999.04.746 5.515 1.061 12.228.704z",
    fill: "#00183A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.453 79.873l1.178.065s-4.823 7.448-7.384 8.017c-.012-.004 4.036-3.795 6.206-8.082z",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.956 82.063c.086.89 1.087 1.927 1.732 1.862.644-.064.725-.799.639-1.688-.086-.89-.697-1.667-1.333-1.586-.644.064-1.128.535-1.038 1.412z",
    fill: "#7FA7B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.552 81.572c.394 3.799 3.353 6.605 5.685 6.368 2.319-.24 3.132-3.434 2.737-7.233-.394-3.799-2.481-5.539-4.796-5.31-2.323.252-4.008 2.38-3.626 6.175z",
    fill: "#7FA7B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.372 79.96c6.204-.328 11.35-.089 12.126.537h.093l-11.59-8.611a1.678 1.678 0 00-2.135.108l-10.603 9.79h.093c.725-.705 5.812-1.494 12.016-1.823z",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.823 79.843l-1.171.137s5.22 7.19 7.814 7.602c0 0-4.242-3.566-6.643-7.739z",
    fill: "#003057"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3D7E9C",
    d: "M81.52 30.51l21.7-5.18 6.973 29.212-21.7 5.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M95.691 36.484l19.682 2.24-3.015 26.495-19.682-2.24zM176.92 124.915l22.195.795-1.018 8.941-22.482-2.558 1.305-7.178z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D7E9C",
    d: "M93.531 86.314l19.788-.918 1.236 26.637-19.788.918z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.8,
    d: "M103.28 81.089l15.964 10.975-2.146 3.121-15.963-10.975zM92.246 104.273l15.964 10.975-2.146 3.121L90.1 107.394z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.328 29.62l25.293-4.79 1.744 6.505h-26.601l-.436-1.716z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D7E9C",
    d: "M156.172 56.397l4.164-1.034 13.647 54.965-4.163 1.034z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D3F4F",
    d: "M169.613 110.528l4.164-1.034.413 1.666-4.163 1.033z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.555 117.506l.356-6.275-3.606.895 3.25 5.38z",
    fill: "#3D7E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.68 104.729s-19.213-33.227-15.946-42.408c3.607-8.985 25.578 20.64 25.231 43.929l-9.285-1.521zM60.87 102.644s19.214-33.227 15.946-42.408c-3.606-8.985-25.577 20.64-25.23 43.929l9.285-1.521z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.738 97.446c5.664-2.376 10.454-4.805 16.92-7.397 37.237 115.459 15.3 143.675-81.132 207.031-14.868 9.711-32.2-15.429-5.791-29.092 92.192-48.187 90.406-66.609 70.003-170.542z",
    fill: "#9BCACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.812 95.361c-5.663-2.376-10.454-4.806-16.919-7.397-37.238 115.459-15.3 143.675 81.132 207.031 14.867 9.711 32.2-15.429 5.79-29.092-92.191-48.187-90.405-66.609-70.003-170.542z",
    fill: "#9BCACC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 46.604,
    y1: 9.813,
    x2: 280.225,
    y2: 156.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA37B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h308v162H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSaveFamilyMemsCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/save-family-mems-card.7f1a7be0df49a26578f5145d1128833f.svg";